// ============================================================================
// Fishing Requirements - Requirements for fishing actions
// ============================================================================
import { createEquippedItemRequirement, createHasPawnSelectedRequirement, } from '../actions/requirements.js';
/**
 * Get the requirements for fishing (at a spot or water edge).
 * Fishing requires a pawn and a fishing rod.
 */
export const getFishingRequirements = () => {
    return [
        createHasPawnSelectedRequirement(),
        createEquippedItemRequirement({ itemCategory: 'fishing_rod' }),
    ];
};
//# sourceMappingURL=requirements.js.map